import { render, staticRenderFns } from "./AddBatteryType.vue?vue&type=template&id=be3c7fb8&scoped=true"
import script from "./AddBatteryType.vue?vue&type=script&lang=js"
export * from "./AddBatteryType.vue?vue&type=script&lang=js"
import style0 from "./AddBatteryType.vue?vue&type=style&index=0&id=be3c7fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3c7fb8",
  null
  
)

export default component.exports